/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerplacementcenter2Inputs */

const en_flyerplacementcenter2 = /** @type {(inputs: Flyerplacementcenter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center`)
};

const de_flyerplacementcenter2 = /** @type {(inputs: Flyerplacementcenter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte`)
};

/**
* | output |
* | --- |
* | "Center" |
*
* @param {Flyerplacementcenter2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerplacementcenter2 = /** @type {((inputs?: Flyerplacementcenter2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerplacementcenter2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerplacementcenter2(inputs)
	return de_flyerplacementcenter2(inputs)
});
export { flyerplacementcenter2 as "flyerPlacementCenter" }